<template>
  <div>
    <div class="stat-select">
      <SelectleaveTimeDate ref="SelectleaveTimeDate" @timeDate="GetLeaveStatisticsSummary_date"></SelectleaveTimeDate>
      <div class="select-more" @click="screen">
        <span>筛选</span>
        <img :src="require('@/assets/attendance/more@2x.png')" />
      </div>
      <div class="stat-show">
        <span v-for="(item, index) in showName" :key="index">{{item.label}}</span>
      </div>
    </div>
    <!-- 请假汇总 -->
    <div class="stat-cont">
      <div class="stat-cont-tit">请假汇总</div>
      <div class="stat-cont-btm">
        <div class="stat-cont-item">
          <div class="stat-top">
            <span class="stat-number">{{dataStat.TotalLeaveTime}}</span>
            <span class="stat-unit">小时</span>
          </div>
          <div class="stat-btm">请假时长</div>
        </div>
        <div class="stat-cont-item">
          <div class="stat-top">
            <span class="stat-number">{{dataStat.TotalLeaveNum}}</span>
            <span class="stat-unit">人</span>
          </div>
          <div class="stat-btm">请假人数</div>
        </div>
        <div class="stat-cont-item">
          <div class="stat-top">
            <span class="stat-number">{{dataStat.TotalTimes}}</span>
            <span class="stat-unit">次</span>
          </div>
          <div class="stat-btm">请假人次</div>
        </div>
      </div>
      <div class="stat-line-box">
        <div class="stat-left"></div>
        <div class="stat-line"></div>
        <div class="stat-right"></div>
      </div>
    </div>
    <!-- 时长占比 -->
    <div class="stat-per">
      <div class="stat-per-tit">时长占比</div>
      <div class="stat-per-box" v-if="leaveRateList.length > 0">
        <div class="stat-per-item" v-for="item in leaveRateList" :key="item.id">
          <div class="stat-per-img">
            <img :src="require('@/assets/attendance/per01@2x.png')" />
          </div>
          <div class="stat-per-progress">
            <div class="per-progress-top">
              <span class="progress-top-name">{{item.typeName}}</span>
              <span class="progress-top-number">{{item.rate}}%</span>
              <span class="progress-top-unit">{{item.time}}小时</span>
            </div>
            <div class="per-progress-btm">
              <van-progress color="#2980FE" :percentage="item.rate" :show-pivot="false" />
            </div>
          </div>
        </div>
      </div>
      <div v-else style="text-align: center; height: 100px;">暂无数据</div>
    </div>
    <div class="end-time">数据截止到：{{xy.moment(EndTime).format('YYYY-MM-DD HH:mm')}}</div>
    <SelectLayer
      ref="SelectLayer"
      :isShowSelectLayer="isShowSelectLayer"
      :layerList="layerList"
      @LayerClose="layerClose"
      @SelectLayer="selectLayer"
    ></SelectLayer>
  </div>
</template>
<script>
import SelectleaveTimeDate from "@/pages/attendance/components/SelectleaveTimeDate";
import SelectLayer from "@/pages/attendance/components/SelectLayer";

export default {
  name: "Stat",
  components: {
    SelectleaveTimeDate,
    SelectLayer
  },
  data() {
    return {
      typeName: "按日统计",
      moreShow: false,

      newDate: "",
      newWeekBegin: "",
      newWeekEnd: "",
      newMonthBegin: "",
      newMonthEnd: "",
      newTermBegin: "",
      newTermEnd: "",
      newCustomBegin: "开始时间",
      newCustomEnd: "结束时间",

      isShowStartDate: false,
      startCurrentDate: new Date(),
      startDate: "", //开始时间
      startHour: "",

      isShowEndDate: false,
      endDate: "", //结束时间
      endHour: "",
      endCurrentDate: new Date(),

      schoolList: [],
      gradelList: [],
      classData: [],

      schoolName: "",
      gradelName: "",
      className: "",
      dataStat: "",
      leaveRateList: [],
      applicationID: 0,
      applicationSubMenuID: 0,
      // ---------------------------调用组件--------------------------------

      timeDate: [],
      StudentNum: "",
      Summary: [],
      EndTime: new Date(),
      isShowSelectLayer: false,
      layerList: [],
      num: 0,

      SchoolDistrictID: 0,
      GradeYearID: 0,
      ClassID: 0,
      ApplicationID: 0,
      ApplicationSubMenuID: 0,
      showName: []
      


    };
  },
  computed: {},
  created() {
    this.GetUserRangeClassPermission();
  },
  mounted() {},
  methods: {
    //获取学年
    async GetUserRangeClassPermission() {
      this.xy.loading();
      console.log(this.$store.state.common)
      // this.applicationID = this.$store.state.common.menuIDs[1]
      // this.applicationSubMenuID = this.$store.state.common.menuIDs[2]
      let idArr = this.$store.state.common.menuIDs
      this.applicationID = idArr[0]
      this.applicationSubMenuID = idArr[1]
      let res = await this.xyapi.get(
        `${this.xyMApi}/base/xy/comm/GetUserRangeClassPermission`,
        {
          applicationID: this.applicationID,
          applicationSubMenuID: this.applicationSubMenuID
        }
      );
      this.xy.unloading();
      if (res.success) {
        let layerList = [];
        layerList = res.data;
        if (layerList.length > 0) {
          // let gradelArr = {
          //   IsCurrent: false,
          //   children: [
          //     {
          //       IsCurrent: false,
          //       children: [],
          //       label: "所有班级",
          //       value: 0
          //     }
          //   ],
          //   label: "所有年级",
          //   value: 0
          // };
          // let classArr = {
          //   IsCurrent: false,
          //   children: [],
          //   label: "所有班级",
          //   value: 0
          // };
          // for (var i = 0; i < layerList.length; i++) {
          //   for (var j = 0; j < layerList[i].children.length; j++) {
          //     layerList[i].children[j].children.splice(0, 0, classArr);
          //   }
          //   layerList[i].children.splice(0, 0, gradelArr);
          // }
          this.layerList = layerList;

          // 默认选中第一个校区
          this.showName = [];
          console.log(this.layerList)
          for (var a = 0; a < this.layerList.length; a++) {
            if (a === 0) {
              this.showName.push(this.layerList[0])
              // for (var s = 0; s < this.layerList[a].children.length; s++) {
              //   if (s === 0) {
              //     this.showName.push(this.layerList[0].children[s])
              //     for (var d = 0; d < this.layerList[0].children[s].children.length; d++) {
              //       if (d === 0) {
              //         this.showName.push(this.layerList[0].children[s].children[d])
              //       }
              //     }
              //   }
              // }
            }
          }
          for (var f = 0; f < this.showName.length; f++ ) {
            this.showName[f].IsCurrent = true
          }
          console.log(this.showName)
          this.SchoolDistrictID = this.layerList[0].value;
          this.GetLeaveStatisticsSummary(this.timeDate);
        } else {
          this.$toast.fail("您无有效的年级班级");
        }
      } else {
        this.$toast.fail(res.msg);
      }
    },

    // 获取数据
    async GetLeaveStatisticsSummary(item) {
      this.num++;
      this.xy.loading();
      this.timeDate = item;
      let params = {
        SchoolDistrictID: this.SchoolDistrictID,
        GradeYearID: this.GradeYearID,
        ClassID: this.ClassID,
        ApplicationID: this.applicationID,
        ApplicationSubMenuID: this.applicationSubMenuID,
        StartTime: this.timeDate[0],
        EndTime: this.timeDate[1]
      };
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          "/api/StudentLeaveMb/GetLeaveStatisticsSummary",
        params
      );
      this.xy.unloading();
      if (res.success) {
        this.dataStat = res.data.LeaveSummary;
        this.EndTime = res.data.EndTime;
        this.leaveRateList = [];
        if (res.data.LeaveRatioSummary.length > 0) {
          for (var i in res.data.LeaveRatioSummary) {
            this.leaveRateList.push({
              rate: res.data.LeaveRatioSummary[i].Ratio,
              time: res.data.LeaveRatioSummary[i].Time,
              id: res.data.LeaveRatioSummary[i].LeaveTypeId,
              typeName: res.data.LeaveRatioSummary[i].LeaveTypeName
            });
          }
        }
      } else {
        this.$toast.fail(res.msg);
      }
    },

    //空方法 赋值数据
    GetLeaveStatisticsSummary_date(item) {
      this.timeDate = item;
      if (this.num !== 0) {
        this.GetLeaveStatisticsSummary(this.timeDate);
      }
    },

    //取消选择开始时间
    startCancel() {
      this.isShowStartDate = false;
    },

    //确认选择开始时间
    startConfirm(value) {
      this.newCustomBegin = value.pattern("yyyy/MM/dd");
      this.startHour = value.pattern("HH:mm");
      this.isShowStartDate = false;
    },

    //取消选择结束时间
    endCancel() {
      this.isShowEndDate = false;
    },

    //确认选择结束时间
    endConfirm(value) {
      this.newCustomEnd = value.pattern("yyyy/MM/dd");
      this.endHour = value.pattern("HH:mm");
      this.isShowEndDate = false;
    },
    
    //筛选
    screen() {
      if (this.layerList.length > 0) {
        this.isShowSelectLayer = true;
      } else {
        this.$toast.fail("您无有效的行政班");
      }
    },

    // 点击关闭
    layerClose(item) {
      this.isShowSelectLayer = item;
    },
    // 确定
    selectLayer(item) {
      this.showName = item
      this.SchoolDistrictID = item[0].value;
      this.GradeYearID = item[1]?item[1].value:0;
      this.ClassID = item[2]?item[2].value:0;
      this.GetLeaveStatisticsSummary(this.timeDate);
    }
  }
};
</script>
<style lang="less" scoped>
.stat-select {
  background: #fff;
  overflow: hidden;
  margin-bottom: 20px;
  .select-time {
    width: 80%;
    height: 72px;
    background: #f3f3f3;
    margin: 8px 20px;
    padding-left: 15px;
    display: inline-block;
    overflow: hidden;
    vertical-align: middle;
    .select-btn {
      display: inline-block;
      height: 72px;
      line-height: 72px;
      width: 33%;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      font-size: 24px;
      color: rgba(22, 22, 22, 1);
      img {
        width: 26px;
        margin: 0 15px;
      }
    }
    .line {
      display: inline-block;
      width: 1px;
      height: 14px;
      background: #d3d3d3;
    }
    .time-show {
      display: inline-block;
      width: 64%;
      white-space: pre;
      img {
        width: 13px;
        display: inline-block;
        margin: 0 15px;
      }
      .time-date {
        display: inline-block;
        text-align: center;
        white-space: pre;
        white-space: nowrap;
        span {
          font-size: 24px;
          margin: 0 10px;
        }
      }
    }
  }
  .select-more {
    display: inline-block;
    vertical-align: middle;
    position: absolute;
    right: 20px;
    top: 120px;
    span {
      margin-right: 10px;
      font-size: 28px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: rgba(96, 96, 96, 1);
    }
    img {
      width: 24px;
    }
  }
  .stat-show {
    width: 100%;
    span {
      display: inline-block;
      color: #2980fe;
      background: #d7e7ff;
      border-radius: 2px;
      margin: 8px 10px;
      padding: 3px 10px;
    }
  }
}
.stat-cont {
  background: #fff;
  overflow: hidden;
  margin: 0 20px;
  .stat-cont-tit {
    font-size: 32px;
    font-weight: 500;
    color: rgba(22, 22, 22, 1);
    margin-top: 14px;
    margin-left: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .stat-cont-btm {
    width: 100%;
    margin-top: 60px;
    margin-bottom: 58px;
    .stat-cont-item {
      display: inline-block;
      width: 33%;
      text-align: center;
      .stat-top {
        width: 70%;
        margin: 0 auto;
        text-align: left;
        .stat-number {
          font-size: 48px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: rgba(22, 22, 22, 1);
        }
        .stat-unit {
          font-size: 24px;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: rgba(96, 96, 96, 1);
        }
      }
      .stat-btm {
        width: 70%;
        margin: 10px auto;
        font-size: 24px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: rgba(96, 96, 96, 1);
        text-align: left;
      }
    }
  }
}
.stat-line-box {
  position: relative;
  .stat-line {
    border: 3px #d7d7d7 dashed;
    margin-bottom: 40px;
  }
  .stat-left {
    width: 30px;
    height: 30px;
    background: #000;
    border-radius: 50%;
    position: absolute;
    top: -13px;
    left: -13px;
    background: rgba(246, 246, 246, 1);
  }
  .stat-right {
    width: 30px;
    height: 30px;
    background: #000;
    border-radius: 50%;
    position: absolute;
    top: -13px;
    right: -13px;
    background: rgba(246, 246, 246, 1);
  }
}
.stat-per {
  background: #fff;
  margin: 0 20px;
  overflow: hidden;
  .stat-per-tit {
    font-size: 32px;
    font-weight: 500;
    color: rgba(22, 22, 22, 1);
    margin-top: 14px;
    margin-left: 20px;
    margin-bottom: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .stat-per-box {
    margin-top: 10px;
    .stat-per-item:last-child{
      .stat-per-progress {
         padding-bottom: 88px;
      }
    }
    .stat-per-item {
      .stat-per-img {
        width: 15%;
        height: 60px;
        display: inline-block;
        margin-top: 44px;
        margin-bottom: 44px;
        text-align: center;
        img {
          width: 46px;
        }
      }
      .stat-per-progress {
        width: 80%;
        display: inline-block;
        margin-top: 44px;
        padding-bottom: 44px;
        border-bottom: 2px solid #eaeaea;
        .per-progress-top {
          margin-bottom: 16px;
          .progress-top-name {
            font-size: 30px;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: rgba(22, 22, 22, 1);
            margin-right: 10px;
            vertical-align: middle;
          }
          .progress-top-number {
            font-size: 24px;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: rgba(96, 96, 96, 1);
            vertical-align: middle;
          }
          .progress-top-unit {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(22, 22, 22, 1);
            vertical-align: middle;
            float: right;
          }
        }
        // .per-progress-btm{}
      }
    }
  }
}

.more {
  .more-top {
    display: flex;
    margin: 10px;
    .more-top-left {
      flex: 0.333;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
      .school {
        margin-top: 40px;
        margin-bottom: 40px;
        word-wrap: break-word;
        word-break: normal;
        text-align: left;
        padding: 0 9px;
      }
      .active {
        color: #2980fe;
      }
    }
    .more-top-cont {
      flex: 0.333;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
      border-left: 1px solid #eaeaea;
      border-right: 1px solid #eaeaea;
      .grade {
        margin-top: 40px;
        margin-bottom: 40px;
        word-wrap: break-word;
        word-break: normal;
        text-align: left;
        padding: 0 9px;
      }
      .active {
        color: #2980fe;
      }
    }
    .more-top-right {
      flex: 0.333;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
      .class-data {
        margin-top: 40px;
        margin-bottom: 40px;
        word-wrap: break-word;
        word-break: normal;
        text-align: left;
        padding: 0 9px;
      }
      .active {
        color: #2980fe;
      }
    }
  }
  .more-btn {
    height: 110px;
    line-height: 110px;
    background: #000;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    .btn {
      flex: 0.5;
      margin: 17px 30px;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
    }
  }
}
.end-time {
  position: fixed;
  bottom: 0;
  text-align: center;
  width: 100%;
  color: #888;
  padding: 7px 0;
  background-color: #f9f9f9 !important;
}
</style>
